module.exports = __webpack_public_path__ + "img/PL09012.a117da90.png";